import { Header } from '../components/Header';
import { Footer } from '../components/Footer';

export function Terms() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Terms of Service</h1>
          
          <div className="prose prose-blue max-w-none">
            <p className="text-lg text-gray-600 mb-8">
              Last updated: {new Date().toLocaleDateString()}
            </p>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Agreement to Terms</h2>
              <p className="text-gray-600 mb-4">
                By accessing or using Skillmatch ("the Service"), you agree to be bound by these Terms of Service. If you disagree with any part of the terms, you do not have permission to access the Service.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Description of Service</h2>
              <p className="text-gray-600 mb-4">
                Skillmatch is a resume optimization service that helps users tailor their resumes for specific job applications using AI technology. The service includes:
              </p>
              <ul className="list-disc pl-6 text-gray-600 space-y-2">
                <li>Resume analysis and optimization</li>
                <li>Job description matching</li>
                <li>ATS-friendly formatting</li>
                <li>Storage of user resumes and job applications</li>
              </ul>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. User Accounts</h2>
              <p className="text-gray-600 mb-4">
                When you create an account with us, you must provide accurate and complete information. You are responsible for maintaining the security of your account and password. You agree to accept responsibility for all activities that occur under your account.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Service Plans and Billing</h2>
              <p className="text-gray-600 mb-4">
                We offer the following service plans:
              </p>
              <ul className="list-disc pl-6 text-gray-600 space-y-2">
                <li>Free Plan: Limited to 3 resume optimizations</li>
                <li>Pro Plan: Up to 100 resume optimizations</li>
              </ul>
              <p className="text-gray-600 mt-4">
                Payment terms and conditions will be clearly communicated before any upgrade to a paid plan.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Intellectual Property</h2>
              <p className="text-gray-600 mb-4">
                The Service and its original content, features, and functionality are owned by Skillmatch and are protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. User Content</h2>
              <p className="text-gray-600 mb-4">
                You retain all rights to your resumes and other content you upload to the Service. By uploading content, you grant us a license to use, modify, and store the content as necessary to provide the Service.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Prohibited Uses</h2>
              <p className="text-gray-600 mb-4">You agree not to:</p>
              <ul className="list-disc pl-6 text-gray-600 space-y-2">
                <li>Use the Service for any illegal purpose</li>
                <li>Attempt to bypass usage limits or service restrictions</li>
                <li>Share account credentials with others</li>
                <li>Upload malicious content or attempt to harm the Service</li>
              </ul>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Disclaimer</h2>
              <p className="text-gray-600 mb-4">
                The Service is provided "as is" without warranties of any kind. We do not guarantee that the Service will be uninterrupted, secure, or error-free.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Limitation of Liability</h2>
              <p className="text-gray-600 mb-4">
                In no event shall Skillmatch be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of the Service.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">10. Changes to Terms</h2>
              <p className="text-gray-600 mb-4">
                We reserve the right to modify these terms at any time. We will notify users of any material changes by posting the new Terms of Service on this page.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">11. Contact Information</h2>
              <p className="text-gray-600 mb-4">
                For any questions about these Terms of Service, please contact us:
              </p>
              <ul className="list-disc pl-6 text-gray-600 space-y-2">
                <li>By email: alish.abdulin@gmail.com</li>
              </ul>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}